module.exports = __webpack_public_path__ + "60327062ce9f9171def8094332e04e81.twig";